export default {"src":"/_next/static/media/truck.a577d902.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};